import { useEffect, useState } from "react";
import {
  filter,
  find,
  includes,
  map,
  toUpper,
  isEmpty,
  propEq,
  path,
  length,
  addIndex,
  pathEq,
  allPass
} from "ramda";
import { useIntl } from "react-intl";
import common from "@/i18n/definitions/common";
import education from "@/i18n/definitions/education";
import Typography from "@mui/material/Typography";
import { getRajoitteetFromMaarays } from "@/utils/rajoitteetUtils";
import LisatiedotHtmlLupa from "@/components/03-templates/HtmlLupanakyma/Lisatiedot";
import rajoitteet from "@/i18n/definitions/rajoitteet";
import { PropTypes } from "prop-types";
import { PaikallisenTietovarastonAvain } from "@/enums";
import localForage from "localforage";
import { sortByLocale } from "@/helpers/html";

export default function OpetuskieletHtml({ maaraykset }) {
  const intl = useIntl();
  const locale = toUpper(intl.locale);
  const [kieletOPH, setKieletOPH] = useState([]);

  /** Fetch kieletOPH from storage */
  useEffect(() => {
    localForage
      .getItem(PaikallisenTietovarastonAvain.KIELET_OPH)
      .then(kielet => setKieletOPH(kielet))
      .catch(err => {
        console.error(err);
      });
  }, []);

  const ensisijaisetOpetuskielet = sortByLocale(
    locale,
    filter(
      maarays =>
        maarays.kohde.tunniste === "opetuskieli" &&
        maarays.koodisto === "kielikoodistoopetushallinto" &&
        includes("ensisijaiset", maarays.meta.changeObjects[0].anchor),
      maaraykset
    )
  );

  const toissijaisetOpetuskielet = sortByLocale(
    locale,
    filter(
      maarays =>
        maarays.kohde.tunniste === "opetuskieli" &&
        maarays.koodisto === "kielikoodistoopetushallinto" &&
        includes("toissijaiset", maarays.meta.changeObjects[0].anchor),
      maaraykset
    )
  );

  const lisatietomaarays = find(
    maarays =>
      maarays.kohde.tunniste === "opetuskieli" &&
      maarays.koodisto === "lisatietoja",
    maaraykset
  );

  return (
    (!isEmpty(ensisijaisetOpetuskielet) ||
      !isEmpty(toissijaisetOpetuskielet)) &&
    !isEmpty(kieletOPH) && (
      <div className="mt-4">
        <Typography component="h3" variant="h3">
          {intl.formatMessage(common.opetuskieli)}
        </Typography>
        {getOpetuskieletHtml(ensisijaisetOpetuskielet, kieletOPH, locale, intl)}
        {!isEmpty(toissijaisetOpetuskielet) && (
          <Typography component="h4" variant="h4">
            {intl.formatMessage(education.voidaanAntaaMyosSeuraavillaKielilla)}
          </Typography>
        )}
        {getOpetuskieletHtml(toissijaisetOpetuskielet, kieletOPH, locale, intl)}
        <LisatiedotHtmlLupa lisatietomaarays={lisatietomaarays} />
      </div>
    )
  );
}

const getOpetuskieletHtml = (opetuskielet, kieletOPH, locale, intl) => {

  const isEnglantiAndEnsisijainen = allPass([
    propEq("koodiarvo", "en"),
    pathEq(["meta", "valikko"], "ensisijaiset")
  ]);

  const englanti = find(isEnglantiAndEnsisijainen, opetuskielet || []);

  const kuvaus = englanti && path(
    ["properties", "value"],
    find(
      propEq("anchor", "opetuskielet.opetuskieli-englanti.ensisijaiset.kuvaus"),
      englanti?.meta?.changeObjects
    )
  );

  return (
    <ul className="ml-8 list-disc mb-4">
      {addIndex(map)(
        (opetuskieli, index) => {

          const ensisijainenEnglantiFound = isEnglantiAndEnsisijainen(opetuskieli);
          const kieliLabel = ensisijainenEnglantiFound && englanti?.arvo > 0
            ? `${kuvaus || "englanti"} ${intl.formatMessage(common.enintaan).toLowerCase()} ${englanti?.arvo || 0} ${intl.formatMessage(education.opiskelijaa)}`
            : path(
              ["metadata", locale, "nimi"],
              find(
                propEq("koodiarvo", toUpper(opetuskieli.koodiarvo)),
                kieletOPH
              )
            );

          return(
            <li
              key={opetuskieli.koodiarvo}
              className={`leading-bulletList ${
                length(opetuskieli.aliMaaraykset) ? "mb-2" : ""
              }`}>
              {kieliLabel}
              <div key={"div-" + index}>
                {length(opetuskieli.aliMaaraykset)
                  ? getRajoitteetFromMaarays(
                    opetuskieli.aliMaaraykset,
                    locale,
                    intl.formatMessage(rajoitteet.ajalla)
                  )
                  : ""}
              </div>
            </li>
          );
        },
        opetuskielet || []
      )}
    </ul>
  );
};

OpetuskieletHtml.propTypes = {
  maaraykset: PropTypes.array
};
